// extracted by mini-css-extract-plugin
export default {"padding":"third_padding__hTvuI","wrapdiv":"third_wrapdiv__NAlFI","service":"third_service__FzqWb","section":"third_section__VBVZV"};